export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";